export class DynamicFormElement
{
  constructor() {
    this.options = new Array<{ label: string, key: string, check: boolean }>();
  }

  key: string;
  label: string;
  value: any;
  type: string;
  validation: any;
  options: { label: string, key: string, check: boolean}[];
  order: number;
  rowCount: number;
  fileType: string;
  require: boolean;
  
}
